import React from 'react';

import './styles.css'

export default function StatusChip({color, label}) {
 return (
    <span className={"status-chip "+color}>
      {label}
    </span>
  );
}